import React from 'react';
import { Menu, LogOut, Sparkles, Search, Command as CommandIcon } from 'lucide-react';
import useAuthStore from '../../stores/authStore';
import useUiStore from '../../stores/uiStore';
import useCommandPaletteStore from '../../stores/commandPaletteStore';
import ThemeToggle from '../shared/ThemeToggle';
import InboxBellDropdown from './InboxBellDropdown';

// Plattform-abhaengiger Modifier (⌘ auf Mac, Ctrl sonst)
const IS_MAC = typeof navigator !== 'undefined' && /Mac|iPhone|iPad/.test(navigator.platform || '');

export default function Header() {
  const { user, logout } = useAuthStore();
  const { toggleSidebar, toggleAgentPanel, agentPanelOpen } = useUiStore();
  const { openPalette } = useCommandPaletteStore();

  return (
    <header className="sticky top-0 z-20 bg-primary-50/90 backdrop-blur-md dark:bg-slate-900/90 dark:backdrop-blur-md border-b border-gray-200 dark:border-slate-700 px-6 py-3 flex items-center justify-between">
      <button onClick={toggleSidebar} className="text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-200 lg:hidden">
        <Menu size={20} />
      </button>

      <div className="flex-1 flex items-center">
        {/* Command-Palette Trigger (⌘K-Hint) */}
        <button
          onClick={openPalette}
          className="group hidden md:flex items-center gap-2 px-3 py-1.5 ml-2 rounded-lg bg-white/80 dark:bg-slate-800/60 border border-gray-200 dark:border-slate-700 hover:border-primary-300 dark:hover:border-primary-600 hover:bg-white dark:hover:bg-slate-800 text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-200 transition-colors"
          title="Command-Palette oeffnen"
        >
          <Search size={14} />
          <span className="text-xs">Suchen oder Befehl ...</span>
          <span className="hidden lg:inline-flex items-center gap-0.5 ml-4 text-[10px] font-mono font-semibold text-gray-400 dark:text-slate-500 bg-gray-100 dark:bg-slate-900 border border-gray-200 dark:border-slate-700 rounded px-1.5 py-0.5">
            {IS_MAC ? <CommandIcon size={10} /> : <span>Ctrl</span>}
            <span>K</span>
          </span>
        </button>

        {/* Mobile-Kompakt: nur Icon */}
        <button
          onClick={openPalette}
          className="md:hidden ml-2 p-1.5 rounded-lg text-gray-500 dark:text-slate-400 hover:text-gray-700 dark:hover:text-slate-200 hover:bg-gray-100 dark:hover:bg-slate-800"
          title="Command-Palette"
          aria-label="Command-Palette oeffnen"
        >
          <Search size={18} />
        </button>
      </div>

      <div className="flex items-center gap-4">
        {/* Agent-Button */}
        <button
          onClick={toggleAgentPanel}
          className={`relative p-1.5 rounded-lg transition-colors ${
            agentPanelOpen
              ? 'bg-indigo-100 text-indigo-700 dark:bg-indigo-900/40 dark:text-indigo-300'
              : 'text-gray-500 dark:text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/20'
          }`}
          title="amplione Agent"
        >
          <Sparkles size={20} />
        </button>

        <InboxBellDropdown />

        <ThemeToggle />

        <div className="flex items-center gap-2">
          <span className="text-sm font-medium text-gray-700 dark:text-slate-300">
            {user?.name || user?.email || 'User'}
          </span>
          <button
            onClick={logout}
            className="text-gray-400 dark:text-slate-500 hover:text-red-600 transition-colors"
            title="Abmelden"
          >
            <LogOut size={18} />
          </button>
        </div>
      </div>
    </header>
  );
}
